import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import googleDriveActions from 'redux/actions/googleDriveActions'
import generalActions from 'redux/actions/generalActions'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.GOOGLE_SLIDES_LMS_OPEN_GOOGLE_CONFIRM

class GoogleSlidesLMSOpenGoogle extends PureComponent {

	openGoogle = () => {
		this.props.actions.LMSOpenGoogle(this.props.redirectUrl)
	}

	close = () => {
		this.props.actions.close(CONFIRM_TYPE)
	}

	render() {
		return (
			<Confirm
				btTwo={localize('global_ok')}
				alertTitle={localize('googleSlides_lmsOpenGoogle_title')}
				alertMessage={localize('googleSlides_lmsOpenGoogle')}
				actionButtonType={0}
				actionTwo={this.openGoogle}
				closeAction={this.close}
			/>
		)
	}
}

GoogleSlidesLMSOpenGoogle.propTypes = {
	actions: PropTypes.shape({
		LMSOpenGoogle: PropTypes.func.isRequired,
		close: PropTypes.func.isRequired,
	}).isRequired,
	redirectUrl: PropTypes.string.isRequired,
}


function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		LMSOpenGoogle: googleDriveActions.LMSOpenGoogleConfirmed,
		close: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GoogleSlidesLMSOpenGoogle)

export { GoogleSlidesLMSOpenGoogle }
